/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Standard_LabelInputs */



/**
* | output |
* | --- |
* | "Caption standard" |
*
* @param {Embed_Captions_Local_Standard_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_standard_label = /** @type {((inputs?: Embed_Captions_Local_Standard_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Standard_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Norme de légende")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bildunterschriftenstandard")
	if (locale === "it") return /** @type {LocalizedString} */ ("Didascalia standard")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Стандарт субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estándar de leyenda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标准字幕")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプション標準")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन मानक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Padrão de legenda")
	return /** @type {LocalizedString} */ ("Caption standard")
});